<div class="no-data-found">
  <tui-icon [style.border-width.rem]="0.25" *ngIf="!hideIcon" icon="@tui.search" class="no-data-found__icon"></tui-icon>

  <h1 class="no-data-found__title">{{ title ?? ('components.loyaltyNoDataFound.labels.title' | translate) }}</h1>

  <p *ngIf="!hideSubtitle" class="no-data-found__subtitle">
    {{ 'components.loyaltyNoDataFound.labels.subtitle' | translate }}
  </p>

  <ng-content></ng-content>
</div>
